// What a live probe is evidence for, folded into the row; pure, so testable without a browser.
// Scoped to the measured host, since surfaces differ; `reasoning` merges one key deep.
export const withMeasured = (row, provider, ...patches) => {
  const patch = Object.assign({}, ...patches.filter(Boolean));
  if (!provider || !Object.keys(patch).length) return null;
  const { reasoning, ...flat } = patch;
  const patches_ = row?.per_provider || {};
  const host = { ...(patches_[provider] || {}), ...flat };
  if (reasoning) host.reasoning = { ...(patches_[provider]?.reasoning || {}), ...reasoning };
  return { ...row, per_provider: { ...patches_, [provider]: host } };
};
